<template>
  <section class="home--about-container">
    <VContainer>
      <div class="title--center mb-4-5">
        {{ $t('media.title') }}
      </div>
      <div class="content content--youtube mb-4-5" ref="iframeWrapper">
        <client-only>
          <iframe
            v-if="iframeVisible"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/H3Eb3aWSncs"
            :title="$t('media.youtube')"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            loading="lazy"
          ></iframe>
        </client-only>
      </div>
    </VContainer>
  </section>
</template>

<script>
export default {
  data() {
    return {
      iframeVisible: false,
      observer: null,
    };
  },
  mounted() {
    const iframeWrapper = this.$refs.iframeWrapper;
    if (!iframeWrapper) return;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.iframeVisible = true;
          this.observer.unobserve(entry.target);
        }
      });
    });

    this.observer.observe(iframeWrapper);
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  },
};
</script>
